export const icons = {
    polandMobileSmall: require('../../../images/projects/polandTagsMobileSmall.png'),
    polandMobileLarge: require('../../../images/projects/polandTagsMobileLarge.png'),
    polandSmall: require('../../../images/projects/polandTagsSmall.png'),
  };